import { render } from "./TransactionEditModal.vue?vue&type=template&id=1f8c0a03&ts=true&lang=pug"
import script from "./TransactionEditModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransactionEditModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__